// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__lfLuM","list":"PatternAutocomplete_list__16PpH"};